import React from 'react'

function Contact() {
    return (
        <div className='col-12 px-0 my-3'>
                    <div className=' heading text-center'>
                        <h2 className='m-0 heading-text '>O nama</h2>
                    </div>

                    <h3 style={{marginTop: '5vh'}}>Trenutno nas možete kontatirati na email: <b>contact@storkini.rs</b></h3><br/>
                    <h3>Uskoro više informacija</h3>
                </div>
    )
}

export default Contact
